// removed by extract-text-webpack-plugin
module.exports = {"keyboard":"Keyboard__keyboard___1v0Qi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Keyboard/Keyboard.scss
// module id = 102
// module chunks = 0